import { render, staticRenderFns } from "./MultipleShortClosedAnswer.vue?vue&type=template&id=74bb31a1&scoped=true&"
import script from "./MultipleShortClosedAnswer.vue?vue&type=script&lang=ts&"
export * from "./MultipleShortClosedAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleShortClosedAnswer.vue?vue&type=style&index=0&id=74bb31a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb31a1",
  null
  
)

export default component.exports